import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BackgroundJobsManagerView = lazy(() =>
	import('./components/views/BackgroundJobsManagerView').then((m) => ({
		default: m.BackgroundJobsManagerView
	}))
);

const backgroundJobsRoutes: FuseRouteItemType[] = [
	{
		path: 'background-jobs',
		element: <BackgroundJobsManagerView />
	}
];

export default backgroundJobsRoutes;
